<template>
    <b-container>
        <h4>
            <router-link :to="{ name: 'events' }" class="mr-2 mb-2">
                <font-awesome-icon icon="arrow-alt-circle-left"></font-awesome-icon>
            </router-link>
            Event Registration
        </h4>
        <div
            v-if="!event.registration_open"
            class="alert alert-info my-2"
        >
            <h3>
                <font-awesome-icon icon="calendar-times"></font-awesome-icon>
                Event Registration Closed
            </h3>
            <i>This event is closed for registration at this time.</i>
        </div>
        <EventInfo
            v-if="event"
            :event="event"
        ></EventInfo>
        <template
            v-if="event.registration_open && event.ticket_settings"
        >
            <template
                v-if="event.tickets_left == 'UNLIMITED' || event.tickets_left > 0"
            >
                <template
                    v-if="!event.ticket_settings.max_user_tickets || event.user_ticket_count < event.ticket_settings.max_user_tickets"
                >
                    <div
                        v-if="event.ticket_settings.show_tickets_left"
                        class="alert alert-info my-2"
                    >
                        <font-awesome-icon
                            icon="info-circle"
                        ></font-awesome-icon>
                        {{ event.tickets_left }} tickets left!
                    </div>
                    <div class="card mt-2">
                        <div class="card-body">
                            <b-form-group>
                                <label>
                                    <b>Ticket request:</b>
                                    <em
                                        v-if="event.ticket_settings.max_user_tickets && event.ticket_settings.show_user_ticket_limit"
                                    >limit {{ event.ticket_settings.max_user_tickets }} per user</em>
                                </label>
                                <b-input v-model.number="tickets_wanted" type="number" :max="event.ticket_settings.max_user_tickets" />
                                <div class="text-center mt-2">
                                    <button
                                        class="sc-btn sc-btn-lg"
                                        @click="registerEvent()"
                                    >
                                        <font-awesome-icon
                                            icon="ticket-alt"
                                            class="mr-1"
                                        ></font-awesome-icon>
                                        Get Tickets
                                    </button>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-info mt-2">
                        <b>
                            <font-awesome-icon
                                icon="info-circle"
                            ></font-awesome-icon>
                            You have reached the maximum amount of tickets allowed per family.
                        </b>
                        <i
                            v-if="event.ticket_settings.allow_user_ticket_requests_after_max"
                        >
                            Additional tickets may be requested at this time, but are not guaranteed as space is limited.
                        </i>
                        <i
                            v-else
                        >
                            Additional tickets may not be requested at this time.
                        </i>
                    </div>
                    <div
                        v-if="event.ticket_settings.allow_user_ticket_requests_after_max"
                        class="card mt-2"
                    >
                        <div class="card-body">
                            <b-form-group>
                                <label><b>Ticket request:</b><em> How many additional tickets would you like for this event?</em></label>
                                <b-input v-model.number="tickets_wanted" type="number" />
                                <div class="text-center mt-2">
                                    <button
                                        class="sc-btn sc-btn-lg float-right"
                                        @click="registerEvent()"
                                    >
                                        <font-awesome-icon
                                            icon="ticket-alt"
                                            class="mr-1"
                                        ></font-awesome-icon>
                                        Request Tickets
                                    </button>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else-if="event.ticket_settings">
                <div class="alert alert-info mt-2">
                    <b>
                        <font-awesome-icon
                            icon="info-circle"
                        ></font-awesome-icon>
                        No tickets are available for this event.
                    </b>
                    <i
                        v-if="event.ticket_settings.allow_user_ticket_requests_after_full"
                    >
                        Tickets may still be requested as additional tickets may become available.
                    </i>
                </div>
                <div
                    v-if="event.ticket_settings.allow_user_ticket_requests_after_full"
                    class="card"
                >
                    <div class="card-body">
                        <b-form-group>
                            <h3>Ticket Request</h3>
                            <label><em> How many tickets would you like for this event?</em></label>
                            <b-form-input v-model.number="tickets_wanted" type="number" />
                            <button
                                class="sc-btn sc-btn-lg float-right mt-2"
                                @click="registerEvent()"
                            >
                                <font-awesome-icon
                                    icon="ticket-alt"
                                    class="mr-1"
                                ></font-awesome-icon>
                                Request Tickets
                            </button>
                        </b-form-group>
                    </div>
                </div>
            </template>
        </template>
    </b-container>
</template>
<script>
import { mapState } from 'vuex';
import EventInfo    from "./EventInfo.vue"

export default {
    props: [ "id" ],
    data() {
        return {
            tickets_wanted: 0,
            event: {}
        };
    },
    mounted() {
        this.loadEvent();
    },
    methods: {
        loadEvent() {
            this.$api.get(`/api/events/get/${this.id}`).then((response) => {
                this.event = response.data.event;
                this.event.ticket_settings = (this.event.ticket_settings || {});
                console.log(this.event);
            });
        },
        registerEvent() {
            this.$api.post(
                `/api/events/register/${this.id}`,
                { tickets_wanted: this.tickets_wanted }
            ).then((response) => {
                this.$bvToast.toast(response.data.message, {
                    title           : "Notification",
                    autoHideDelay   : 5000,
                    appendToast     : true
                });
                this.$router.push({ name: "view_event_tickets", params: { id: this.id } });
            });
        }
    },
    computed: mapState(["user"]),
    components: { EventInfo }    
}
</script>